import React from "react";
import { ArrowRight } from "lucide-react";

const RegisterSection = () => {
  return (
    <section
      id="register"
      className="smym-section border-t border-[var(--smym-line)] px-4 sm:px-6"
    >
      <div className="mx-auto max-w-xl text-center">
        <h2 className="smym-section-title mb-4">Membership</h2>
        <p className="mx-auto mb-8 text-[var(--smym-ink-muted)] [max-width:42ch]">
          Open to Maheshwari youth in Chennai. The form takes about five minutes.
        </p>
        <a href="/member-registration" className="smym-btn smym-btn-primary">
          Open membership form
          <ArrowRight size={18} strokeWidth={2.25} aria-hidden />
        </a>
      </div>
    </section>
  );
};

export default RegisterSection;
